// Light / dark / follow-the-system, remembered per browser. Light is the
// default so nothing changes for anyone until they choose. The choice lands
// on <html data-theme="light|dark"> (the resolved value), which is what the
// dark overrides in styles/darkTheme.css key off.
const KEY = 'blade-theme';
export const MODES = ['light', 'dark', 'system'];

export const getMode = () => {
  try {
    const stored = localStorage.getItem(KEY);
    return MODES.includes(stored) ? stored : 'light';
  } catch { return 'light'; }
};

const systemPrefersDark = () => typeof window !== 'undefined'
  && typeof window.matchMedia === 'function'
  && window.matchMedia('(prefers-color-scheme: dark)').matches;

export const resolveMode = (mode, prefersDark = systemPrefersDark()) => {
  if (mode === 'dark') return 'dark';
  if (mode === 'system') return prefersDark ? 'dark' : 'light';
  return 'light';
};

export const applyTheme = (mode = getMode()) => {
  const resolved = resolveMode(mode);
  const root = document.documentElement;
  root.setAttribute('data-theme', resolved);
  // Tells the browser to draw scrollbars and form controls to match.
  root.style.colorScheme = resolved;
  return resolved;
};

export const setMode = (mode) => {
  const next = MODES.includes(mode) ? mode : 'light';
  try { localStorage.setItem(KEY, next); } catch { /* the choice just won't persist */ }
  window.dispatchEvent(new CustomEvent('blade-theme-change', { detail: next }));
  return applyTheme(next);
};

// light -> dark -> system -> light, for a single toggle button.
export const nextMode = (mode) => MODES[(MODES.indexOf(mode) + 1) % MODES.length];

// Call once at start-up: applies the saved choice and tracks the OS setting
// while in "system" mode. Returns a cleanup function.
export const initTheme = () => {
  applyTheme();
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {};
  const query = window.matchMedia('(prefers-color-scheme: dark)');
  const onChange = () => { if (getMode() === 'system') applyTheme('system'); };
  if (query.addEventListener) query.addEventListener('change', onChange);
  return () => { if (query.removeEventListener) query.removeEventListener('change', onChange); };
};
